import React, { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Button from "../../../components/shared/Button/Button";
import Spinner from "../../../components/shared/spinner/Spinner";
import { useSwingCollection } from "../hooks/useSwingCollection";
import { HiChevronLeft } from "react-icons/hi";
import { InputRenameCollection } from "../InputRenameCollection";
import { TbTrash } from "react-icons/tb";
import SummaryAI from "./components/SummaryAI";
import DeleteCollectionModal from "./components/DeleteCollectionModal";
import CollectionSwingTable from "./CollectionSwingTable";
import AddSwingsTable from "./AddSwingsTable";
import CollectionTableFilters from "./CollectionTableFilters";
import FiltersRow from "../../swing_library/components/FiltersRow/FiltersRow";
import Newton from "../../swing_library/components/Newton/Newton";

export default function Collection() {
  const history = useHistory();
  const { collectionId } = useParams();

  const { collection, isLoading } = useSwingCollection(collectionId);

  const [isEditing, setIsEditing] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const handleCompare = () => {
    history.push(`/compare?ids=${collectionId}`);
  };

  if (isLoading) {
    return (
      <div className="flex h-[50vh] items-center justify-center">
        <Spinner color="primary500" size="md" />
      </div>
    );
  }

  if (!collection) {
    return (
      <div className="flex h-[50vh] items-center justify-center">
        <div className="text-gray700 text-lg">Collection not found</div>
      </div>
    );
  }

  return (
    <>
      <div className="custom-margin-top-20 w-full p-5">
        <Button
        className="mb-2"
        color="gray100"
        isIconOnly
        onClick={() => history.push("/collections")}
        rounded="full"
        size="xs"
      >
        <HiChevronLeft className="text-gray700" />
      </Button>

      {/* Header Section */}
      <div className="mb-6 flex items-start justify-between gap-4">
        <div className="w-full max-w-[512px]">
          {!isEditing ? (
            <div className="flex flex-col gap-1">
              <div className="text-gray700 truncate text-lg font-semibold">
                {collection.collectionName}
              </div>

              <div
                className="w-fit text-primary700 cursor-pointer text-xs font-semibold underline"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsEditing(true);
                }}
              >
                Rename
              </div>
            </div>
          ) : (
            <InputRenameCollection
              collection={collection}
              onCancel={() => setIsEditing(false)}
              onSubmit={() => setIsEditing(false)}
              size="md"
            />
          )}
        </div>

        <div className="flex items-center gap-3">
          <Button
            color="white/error300"
            onClick={() => setIsDeleteModalOpen(true)}
            startContent={<TbTrash className="size-5" />}
          >
            Delete Collection
          </Button>
          <Button color="primary500" onClick={handleCompare}>
            Compare
          </Button>
        </div>
      </div>

      <SummaryAI collectionOne={collection} />

      <div className="my-6 w-full">
        <CollectionTableFilters />
      </div>

      <CollectionSwingTable collection={collection} />

      <div className="my-8 text-xl font-semibold">Add more swings</div>

      <div className="mb-8 flex w-full flex-wrap items-center gap-3">
        <FiltersRow />
      </div>

      <AddSwingsTable collection={collection} />

      <DeleteCollectionModal
        collectionId={collectionId}
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
      />
      </div>

      <Newton />
    </>
  );
}
